'use client';

import { useState } from 'react';
import { MediaViewer, type ViewerFile } from '@/app/inbox/Attachments';
import { useCanShareFiles } from '@/components/ShareFileButton';

/**
 * Open a PDF or image. On a phone it shows in the in-app viewer with Close and Share; the installed
 * app has no browser bar, so a new tab there is a page the user cannot share from or leave.
 * Render `viewer` once in the component.
 */
export function useFileViewer() {
  const inApp = useCanShareFiles();
  const [file, setFile] = useState<ViewerFile | null>(null);

  const open = (next: ViewerFile) => {
    if (inApp) setFile(next);
    else window.open(next.url, '_blank', 'noopener,noreferrer');
  };

  const viewer = <MediaViewer files={file ? [file] : []} index={file ? 0 : null} onClose={() => setFile(null)} />;
  return { open, viewer, inApp };
}
